import { combineReducers } from '@reduxjs/toolkit';
import registrationReducer from './registration/slice';
import loginReducer from './login/slice';
import passwordReducer from './passwordManagement/slice';
import { signInReducer } from './signin/slice';

const authReducer = combineReducers({
  registration: registrationReducer,
  login: loginReducer,
  password: passwordReducer,
  signin: signInReducer,
});

export default authReducer;
